import React from "react";
import { Box, Typography } from "@mui/material";

const Tag = (props) => {
    return(
        <Box sx={{
            padding: '0.35rem 0.85rem',
            margin: '0.35rem',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '9999px',
            border: '1px solid rgba(59, 130, 246, 0.2)',
            transition: 'all 0.2s ease',
            '&:hover': {
                backgroundColor: 'rgba(59, 130, 246, 0.15)',
                borderColor: 'rgba(59, 130, 246, 0.4)',
                transform: 'translateY(-1px)'
            }
        }}>
            <Typography variant="note" sx={{
                color: '#3b82f6',
                fontWeight: 500,
                fontSize: '0.8rem',
                whiteSpace: 'nowrap'
            }}>{props.name}</Typography>
        </Box>
    );
};

export default Tag;
